<template>
    <div class="popup_notifications" id="notificationsList" :class="{group: group, all: !group, start: first_time_loaded, 'to-back': goToGroup}" @click="showAllNotifications">
        <template v-for="(notification, index) in notifications.filter(el => el.seen == 0)">
            <div class="notification" :style="{'--index': index}" :id="notification.id">
                <div class="avatar">
                    <img :src="notification.avatar">
                </div>
                <div class="content-notification" @click="clickOnNotification(notification)">
                    <p :class="{inGroup: group}" v-html="notification.name"></p>
                </div>
                <div class="close" @click.stop="group ? clearAllNotifications() : removeNotification(notification)">
                    <icon-close/>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import IconClose from "../Icons/Close"

    export default {
        data() {
            return{
				notifications: [],
                countUnread: 0,
                group: false,
                first_time_loaded: true,
                goToGroup: false,
				procedures_fe_link: process.env.VUE_APP_PROCEDURES_FE_LINK,
				organigram_fe_link: process.env.VUE_APP_ORGANIGRAM_FE_LINK
            }
        },
        components: {
            IconClose
        },
        async mounted(){
			await this.getNotifications();

            this.$root.$on("updateNotificationsList", (parsedData) => {
				if(parsedData.for_personal){
					this.notifications.unshift(parsedData);
				}
			});
            
            window.addEventListener('click', (e) => {   
                if (!document.getElementById('notificationsList').contains(e.target)){
                     if(!this.group && this.group != null) {
                        this.goToGroup = true;
                        setTimeout(() => {
                            this.group = true
                            this.goToGroup = false;
                        }, 200)
                    }
                }
            });
        },
        methods: {
            async getNotifications(){
				await axios.get(`${process.env.VUE_APP_CENTRAL_BE_LINK}/api/notification-list`).then(({data}) => {
					this.notifications = data.data.notification_logs && data.data.notification_logs.length ? data.data.notification_logs.filter(el => el.seen == 0) : [];
                    this.countUnread = data.data.count_unread
                    if(this.notifications.length > 3){
                        this.group = true
                    }

				}).catch(error => {
					if(error.response) {
						if(error.response.status == 500) {
							alert(this.$t('error.500'))
						}
					}
				})
			},
			viewItem(itemSlug, notification, column){
				var modal_type_kr = ''
                this.markAsRead(notification); 
                
				if(notification.frontend_type == 'key_results' || notification.frontend_type == 'logs'){
					modal_type_kr = 'actualizari'
					this.$router.push({ name: 'show-objective-modal', params: { slug: itemSlug, krId: notification.additional_data.key_result_id, modalType: modal_type_kr }})
				}else if(notification.frontend_type == 'comments'){
					modal_type_kr = 'comentarii'
					this.$router.push({ name: 'show-objective-modal', params: { slug: itemSlug, krId: notification.additional_data.key_result_id, modalType: modal_type_kr }})
				}else if(notification.frontend_type == 'tasks'){
					window.location.href = `${this.organigram_fe_link}/dashboard`
				}else if(notification.frontend_type == 'evaluations'){
					window.location.href = `${this.organigram_fe_link}/user/${itemSlug}`
				}else if (notification.frontend_type == 'announces') {
					window.location.href = `${this.organigram_fe_link}/announcements/${itemSlug}`
				}else if (notification.frontend_type == 'departments') {
					window.location.href = `${this.organigram_fe_link}/company`
				}else if (notification.frontend_type == 'procedures') {
					window.location.href = `${this.procedures_fe_link}/procedure/${itemSlug}`
				}else if (notification.frontend_type == 'processes') {
					window.location.href = `${this.procedures_fe_link}/process/${itemSlug}`
				}else{
					this.$router.push({ name: 'show-objective', params: { slug: itemSlug }})
				}

			},
			markAsRead(notification){
				axios.patch(`${process.env.VUE_APP_CENTRAL_BE_LINK}/api/notifications/` + notification.id)
				.then(({data}) => {
					var contentNotification = document.querySelector(`#notification-box-${notification.id} .content-notification`)
					if(contentNotification){contentNotification.classList.remove('new')}
				});
			},
            removeNotification(notification){
                const element = document.getElementById(notification.id)
                element.remove()

                this.markAsRead(notification)
            },
            showAllNotifications(){
                this.first_time_loaded = false;
                this.group = false;
            },
            clearAllNotifications(){
                this.notifications.forEach(el => this.removeNotification(el));
            },
            clickOnNotification(notification){
                if(this.group == false){
                    if(notification.need_link){
                        this.viewItem(notification.entity_slug, notification, 'personal');
                    }
                }
            }
        }
    }
</script>
